// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultInfoItem_wrapper__e3BIL","info":"ResultInfoItem_info__bPONT"};